import { useState } from 'react';

export default function Subscriptions() {
  const [showModalTranquilidad, setShowModalTranquilidad] = useState(false);
  const [showModalElite, setShowModalElite] = useState(false);
  const [formDataTranquilidad, setFormDataTranquilidad] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    plan: 'Plan Tranquilidad',
    periodo: 'mensual'
  });
  const [formDataElite, setFormDataElite] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    plan: 'Plan Élite Integral',
    periodo: 'mensual'
  });
  const [submittingTranquilidad, setSubmittingTranquilidad] = useState(false);
  const [submittingElite, setSubmittingElite] = useState(false);
  const [successTranquilidad, setSuccessTranquilidad] = useState(false);
  const [successElite, setSuccessElite] = useState(false);

  const handleSubmitTranquilidad = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmittingTranquilidad(true);

    const formElement = e.target as HTMLFormElement;
    const formData = new FormData(formElement);

    try {
      await fetch('https://readdy.ai/api/form/d6gsev1tp4hj31tchri0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      setSuccessTranquilidad(true);
      setTimeout(() => {
        setShowModalTranquilidad(false);
        setSuccessTranquilidad(false);
        setFormDataTranquilidad({
          nombre: '',
          email: '',
          telefono: '',
          direccion: '',
          plan: 'Plan Tranquilidad',
          periodo: 'mensual'
        });
      }, 2000);
    } catch (error) {
      console.error('Error al enviar formulario:', error);
    } finally {
      setSubmittingTranquilidad(false);
    }
  };

  const handleSubmitElite = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmittingElite(true);

    const formElement = e.target as HTMLFormElement;
    const formData = new FormData(formElement);

    try {
      await fetch('https://readdy.ai/api/form/d6gsev1tp4hj31tchrhg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      setSuccessElite(true);
      setTimeout(() => {
        setShowModalElite(false);
        setSuccessElite(false);
        setFormDataElite({
          nombre: '',
          email: '',
          telefono: '',
          direccion: '',
          plan: 'Plan Élite Integral',
          periodo: 'mensual'
        });
      }, 2000);
    } catch (error) {
      console.error('Error al enviar formulario:', error);
    } finally {
      setSubmittingElite(false);
    }
  };

  return (
    <section id="suscripciones" className="relative py-16 md:py-32 px-4 md:px-8 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      {/* Patrón de fondo sutil */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 50px, #003366 50px, #003366 51px), repeating-linear-gradient(90deg, transparent, transparent 50px, #003366 50px, #003366 51px)'
      }}></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        {/* Encabezado */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#FF6600]/10 border border-[#FF6600]/30 px-4 md:px-5 py-2 rounded-full mb-4 md:mb-6">
            <i className="ri-shield-check-line text-[#FF6600] text-base md:text-lg"></i>
            <span className="text-[#003366] font-semibold text-xs md:text-sm tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>
              PLANES DE MANTENIMIENTO
            </span>
          </div>

          <h2 className="text-[#003366] font-bold text-2xl md:text-5xl lg:text-6xl mb-4 md:mb-6 leading-tight px-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Asegura la tranquilidad de tu hogar todo el año
          </h2>

          <p className="text-gray-600 text-base md:text-xl max-w-3xl mx-auto leading-relaxed px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Elige el plan de mantenimiento que mejor se adapte a ti y olvídate de los sustos eléctricos y fallos en tu domótica.
          </p>
        </div>

        {/* Tarjetas de Precios */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto mb-8 md:mb-12">
          {/* Plan Tranquilidad */}
          <div className="bg-white border-2 border-gray-200 rounded-3xl p-6 md:p-10 hover:shadow-2xl transition-all duration-300 hover:border-[#003366]/30 relative">
            <div className="mb-6 md:mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#003366]/10 rounded-xl">
                  <i className="ri-shield-line text-[#003366] text-xl md:text-2xl"></i>
                </div>
                <h3 className="text-[#003366] font-bold text-xl md:text-3xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Plan Tranquilidad
                </h3>
              </div>
              <p className="text-gray-600 text-sm md:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                La opción accesible para tu tranquilidad diaria
              </p>
            </div>

            <div className="mb-6 md:mb-8">
              <div className="flex items-baseline gap-2 mb-2">
                <span className="text-[#003366] font-bold text-3xl md:text-5xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>9,90€</span>
                <span className="text-gray-500 text-lg md:text-xl">/mes</span>
              </div>
              <div className="bg-[#FFCC00]/10 border border-[#FFCC00]/30 px-3 md:px-4 py-2 rounded-lg inline-block">
                <span className="text-[#003366] font-semibold text-xs md:text-sm">o 99€/año - ¡Ahorras 2 meses!</span>
              </div>
            </div>

            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10">
              {[
                'Línea prioritaria de WhatsApp (L-V)',
                'Videodiagnóstico ilimitado para averías y domótica',
                'Cero coste de desplazamiento en caso de avería (Ahorras 40€-50€ por visita)',
                '10% de descuento en futuras instalaciones o reformas'
              ].map((benefit, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-xs md:text-sm font-bold"></i>
                  </div>
                  <span className="text-gray-700 text-sm md:text-lg leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {benefit}
                  </span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => setShowModalTranquilidad(true)}
              className="w-full bg-white border-2 border-[#003366] text-[#003366] px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-base md:text-lg hover:bg-[#003366] hover:text-white transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Quiero el Plan Tranquilidad
            </button>
          </div>

          {/* Plan Élite Integral */}
          <div className="bg-gradient-to-br from-[#FF6600] to-[#FF8833] rounded-3xl p-6 md:p-10 hover:shadow-2xl transition-all duration-300 relative overflow-hidden transform hover:scale-[1.02]">
            {/* Badge Recomendado */}
            <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-white px-3 md:px-4 py-1.5 md:py-2 rounded-full shadow-lg">
              <span className="text-[#FF6600] font-bold text-xs md:text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                ⭐ RECOMENDADO
              </span>
            </div>

            <div className="mb-6 md:mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-vip-crown-line text-white text-xl md:text-2xl"></i>
                </div>
                <h3 className="text-white font-bold text-xl md:text-3xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Plan Élite Integral
                </h3>
              </div>
              <p className="text-white/90 text-sm md:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Protección total VIP para tu hogar
              </p>
            </div>

            <div className="mb-6 md:mb-8">
              <div className="flex items-baseline gap-2 mb-2">
                <span className="text-white font-bold text-3xl md:text-5xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>49,00€</span>
                <span className="text-white/80 text-lg md:text-xl">/mes</span>
              </div>
              <div className="bg-white/20 backdrop-blur-sm px-3 md:px-4 py-2 rounded-lg inline-block">
                <span className="text-white font-semibold text-xs md:text-sm">o 490€/año</span>
              </div>
            </div>

            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10">
              {[
                'Todo lo incluido en el Plan Tranquilidad',
                'Urgencias 24/7 con prioridad absoluta',
                '1 Revisión Física Anual Preventiva (Cuadro eléctrico, apriete de bornes, test de tierra y sensores)',
                '1 Hora de Mano de Obra GRATIS al año (Para colgar lámparas, cambiar enchufes, etc.)'
              ].map((benefit, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-white rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#FF6600] text-xs md:text-sm font-bold"></i>
                  </div>
                  <span className="text-white text-sm md:text-lg leading-relaxed font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {benefit}
                  </span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => setShowModalElite(true)}
              className="w-full bg-white text-[#FF6600] px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:bg-gray-50 hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Quiero ser Cliente Élite
            </button>
          </div>
        </div>

        {/* Términos y Condiciones */}
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-gray-500 text-xs leading-relaxed text-center" style={{ fontFamily: 'Inter, sans-serif', fontSize: '11px' }}>
            <strong>Términos y condiciones:</strong> Suscripción con compromiso de permanencia mínimo de 6 meses. El coste de desplazamiento gratuito es aplicable exclusivamente a Colmenar Viejo y un radio de 15 km. Las reparaciones no incluyen el coste de piezas, repuestos ni materiales nuevos, solo eximen del pago del desplazamiento. La hora de mano de obra gratuita del Plan Élite no es acumulable de un año para otro. Precios con IVA no incluido.
          </p>
        </div>
      </div>

      {/* Modal Plan Tranquilidad */}
      {showModalTranquilidad && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6 md:p-8 relative">
            <button
              onClick={() => setShowModalTranquilidad(false)}
              className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-gray-600 text-xl"></i>
            </button>

            <div className="mb-6">
              <h3 className="text-[#003366] font-bold text-2xl md:text-3xl mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Plan Tranquilidad
              </h3>
              <p className="text-gray-600 text-sm md:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Completa tus datos para contratar el plan
              </p>
            </div>

            {successTranquilidad ? (
              <div className="py-12 text-center">
                <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-white text-4xl"></i>
                </div>
                <h4 className="text-[#003366] font-bold text-2xl mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  ¡Solicitud Enviada!
                </h4>
                <p className="text-gray-600" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Nos pondremos en contacto contigo pronto
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmitTranquilidad} data-readdy-form id="form-tranquilidad">
                <input type="hidden" name="plan" value="Plan Tranquilidad" />
                
                <div className="space-y-4 md:space-y-5">
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Nombre completo *
                    </label>
                    <input
                      type="text"
                      name="nombre"
                      required
                      value={formDataTranquilidad.nombre}
                      onChange={(e) => setFormDataTranquilidad({ ...formDataTranquilidad, nombre: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#003366] focus:outline-none transition-colors text-sm"
                      placeholder="Tu nombre"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formDataTranquilidad.email}
                      onChange={(e) => setFormDataTranquilidad({ ...formDataTranquilidad, email: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#003366] focus:outline-none transition-colors text-sm"
                      placeholder="tu@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Teléfono *
                    </label>
                    <input
                      type="tel"
                      name="telefono"
                      required
                      value={formDataTranquilidad.telefono}
                      onChange={(e) => setFormDataTranquilidad({ ...formDataTranquilidad, telefono: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#003366] focus:outline-none transition-colors text-sm"
                      placeholder="600 000 000"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Dirección completa *
                    </label>
                    <input
                      type="text"
                      name="direccion"
                      required
                      value={formDataTranquilidad.direccion}
                      onChange={(e) => setFormDataTranquilidad({ ...formDataTranquilidad, direccion: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#003366] focus:outline-none transition-colors text-sm"
                      placeholder="Calle, número, ciudad"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Periodo de pago *
                    </label>
                    <select
                      name="periodo"
                      required
                      value={formDataTranquilidad.periodo}
                      onChange={(e) => setFormDataTranquilidad({ ...formDataTranquilidad, periodo: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#003366] focus:outline-none transition-colors text-sm cursor-pointer"
                    >
                      <option value="mensual">Mensual - 9,90€/mes</option>
                      <option value="anual">Anual - 99€/año (Ahorras 2 meses)</option>
                    </select>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={submittingTranquilidad}
                  className="w-full bg-[#003366] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-base md:text-lg hover:bg-[#002244] transition-all duration-300 mt-6 md:mt-8 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {submittingTranquilidad ? 'Enviando...' : 'Contratar Plan Tranquilidad'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Modal Plan Élite */}
      {showModalElite && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6 md:p-8 relative">
            <button
              onClick={() => setShowModalElite(false)}
              className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-gray-600 text-xl"></i>
            </button>

            <div className="mb-6">
              <div className="flex items-center gap-3 mb-2">
                <h3 className="text-[#FF6600] font-bold text-2xl md:text-3xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Plan Élite Integral
                </h3>
                <span className="bg-[#FF6600] text-white px-3 py-1 rounded-full text-xs font-bold">VIP</span>
              </div>
              <p className="text-gray-600 text-sm md:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Completa tus datos para contratar el plan
              </p>
            </div>

            {successElite ? (
              <div className="py-12 text-center">
                <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-white text-4xl"></i>
                </div>
                <h4 className="text-[#FF6600] font-bold text-2xl mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  ¡Solicitud Enviada!
                </h4>
                <p className="text-gray-600" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Nos pondremos en contacto contigo pronto
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmitElite} data-readdy-form id="form-elite">
                <input type="hidden" name="plan" value="Plan Élite Integral" />
                
                <div className="space-y-4 md:space-y-5">
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Nombre completo *
                    </label>
                    <input
                      type="text"
                      name="nombre"
                      required
                      value={formDataElite.nombre}
                      onChange={(e) => setFormDataElite({ ...formDataElite, nombre: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#FF6600] focus:outline-none transition-colors text-sm"
                      placeholder="Tu nombre"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formDataElite.email}
                      onChange={(e) => setFormDataElite({ ...formDataElite, email: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#FF6600] focus:outline-none transition-colors text-sm"
                      placeholder="tu@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Teléfono *
                    </label>
                    <input
                      type="tel"
                      name="telefono"
                      required
                      value={formDataElite.telefono}
                      onChange={(e) => setFormDataElite({ ...formDataElite, telefono: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#FF6600] focus:outline-none transition-colors text-sm"
                      placeholder="600 000 000"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Dirección completa *
                    </label>
                    <input
                      type="text"
                      name="direccion"
                      required
                      value={formDataElite.direccion}
                      onChange={(e) => setFormDataElite({ ...formDataElite, direccion: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#FF6600] focus:outline-none transition-colors text-sm"
                      placeholder="Calle, número, ciudad"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Periodo de pago *
                    </label>
                    <select
                      name="periodo"
                      required
                      value={formDataElite.periodo}
                      onChange={(e) => setFormDataElite({ ...formDataElite, periodo: e.target.value })}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#FF6600] focus:outline-none transition-colors text-sm cursor-pointer"
                    >
                      <option value="mensual">Mensual - 49,00€/mes</option>
                      <option value="anual">Anual - 490€/año</option>
                    </select>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={submittingElite}
                  className="w-full bg-[#FF6600] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-base md:text-lg hover:bg-[#FF5500] transition-all duration-300 mt-6 md:mt-8 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {submittingElite ? 'Enviando...' : 'Contratar Plan Élite Integral'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </section>
  );
}